import { action } from "typesafe-actions";
import { BulkPaymentTypes, BulkPaymentApprovalPayload, BulkPaymentCheckPayload, BulkPaymentCheckItem, BulkPaymentExportPayload, BulkPaymentFilesPayload, BulkPaymentFilesResponse, BulkPaymentRejectPayload } from "./types";
import {
  BulkPay,
  BulkPayload,
  BulkPaymentChecker,
  FilePreview,
  PaymentFile,
} from "../../interfaces/BulkPayment";

export const uploadFile = (payload: FormData) =>
  action(BulkPaymentTypes.UPLOAD_FILE, payload);

export const uploadFailure = (error: any) =>
  action(BulkPaymentTypes.UPLOAD_FILE_FAILURE, error);

export const uploadSuccess = (response: any) =>
  action(BulkPaymentTypes.UPLOAD_FILE_SUCCESS, response);

export const uploadFailed = (error: any) =>
  action(BulkPaymentTypes.UPLOAD_FILE_FAILED, error);

export const getProviders = () => action(BulkPaymentTypes.GET_PROVIDERS);

export const getProviderSuccess = (response: any) =>
  action(BulkPaymentTypes.GET_PROVIDERS_SUCCESS, response);

export const uploadedFilePreview = (fileId: number) =>
  action(BulkPaymentTypes.FILE_PREVIEW_REQUEST, fileId);

export const fileListSuccess = (response: FilePreview[]) =>
  action(BulkPaymentTypes.FILE_PREVIEW, response);

export const bulkPaymentIncreaseStep = (step: number) =>
  action(BulkPaymentTypes.INCREASE_BULK_PAYMENT_STEP, step);

export const bulkPaymentDecreaseStep = (step: number) =>
  action(BulkPaymentTypes.DECREASE_BULK_PAYMENT_STEP, step);

export const clearStates = () => action(BulkPaymentTypes.CLEAR_STATES);

export const bulkPaymentRequest = (payload: BulkPayload) =>
  action(BulkPaymentTypes.COMPLETE_PAYMENT_REQUEST, payload);

export const bulkPaymentSuccess = (response: BulkPay) =>
  action(BulkPaymentTypes.COMPLETE_PAYMENT_SUCCESS, response);

export const bulkPaymentFailure = (error: any) =>
  action(BulkPaymentTypes.COMPLETE_PAYMENT_FAILURE, error);

export const getFilesRequest = (payload: BulkPaymentFilesPayload) =>
  action(BulkPaymentTypes.GET_BULKPAYMENT_FILES_REQUEST, payload);

export const getFilesSuccess = (response: BulkPaymentFilesResponse) =>
  action(BulkPaymentTypes.GET_BULKPAYMENT_FILES_SUCESS, response);

export const getFilesFailure = (error: any) =>
  action(BulkPaymentTypes.GET_BULKPAYMENT_FILES_FAILURE, error);

export const submitToCheckerRequest = (fileId: number) =>
  action(BulkPaymentTypes.SUBMIT_TO_CHECKER_REQUEST, fileId);

export const submitToCheckerSuccess = (response: any) =>
  action(BulkPaymentTypes.SUBMIT_TO_CHECKER_SUCCESS, response);

export const submitToCheckerFailure = (error: any) =>
  action(BulkPaymentTypes.SUBMIT_TO_CHECKER_FAILURE, error);

export const approveBulkPaymentRequest = (payload: BulkPaymentApprovalPayload) =>
  action(BulkPaymentTypes.APPROVE_BULK_PAYMENT_REQUEST, payload);

export const approveBulkPaymentSuccess = (response: any) =>
  action(BulkPaymentTypes.APPROVE_BULK_PAYMENT_SUCCESS, response);

export const approveBulkPaymentFailure = (error: any) =>
  action(BulkPaymentTypes.APPROVE_BULK_PAYMENT_FAILURE, error);

export const rejectBulkPaymentRequest = (payload: BulkPaymentRejectPayload) =>
  action(BulkPaymentTypes.REJECT_BULK_PAYMENT_REQUEST, payload);

export const rejectBulkPaymentSuccess = (response: any) =>
  action(BulkPaymentTypes.REJECT_BULK_PAYMENT_SUCCESS, response);

export const rejectBulkPaymentFailure = (error: any) => ({
  type: BulkPaymentTypes.REJECT_BULK_PAYMENT_FAILURE,
  payload: error,
});

export const clearBulkPaymentStates = () => ({
  type: BulkPaymentTypes.CLEAR_BULK_PAYMENT_STATES,
});

export const bulkPaymentCheckRequest = (payload: BulkPaymentCheckPayload) =>
  action(BulkPaymentTypes.BULK_PAYMENT_CHECK_REQUEST, payload);

export const bulkPaymentCheckSuccess = (response: BulkPaymentCheckItem[]) =>
  action(BulkPaymentTypes.BULK_PAYMENT_CHECK_SUCCESS, response);

export const bulkPaymentCheckFailure = (error: any) =>
  action(BulkPaymentTypes.BULK_PAYMENT_CHECK_FAILURE, error);

export const downloadSampleFileRequest = () =>
  action(BulkPaymentTypes.DOWNLOAD_SAMPLE_FILE_REQUEST);

export const downloadSampleFileSuccess = () =>
  action(BulkPaymentTypes.DOWNLOAD_SAMPLE_FILE_SUCCESS);

export const downloadSampleFileFailure = (error: any) =>
  action(BulkPaymentTypes.DOWNLOAD_SAMPLE_FILE_FAILURE, error);

export const bulkPaymentExportRequest = (payload: BulkPaymentExportPayload) =>
  action(BulkPaymentTypes.BULK_PAYMENT_EXPORT_REQUEST, payload);

export const bulkPaymentExportSuccess = () =>
  action(BulkPaymentTypes.BULK_PAYMENT_EXPORT_SUCCESS);

export const bulkPaymentExportFailure = (error: any) =>
  action(BulkPaymentTypes.BULK_PAYMENT_EXPORT_FAILURE, error);
